import { months } from '../consts';

export function getMonthName(dueDate: string) {
  if (dueDate.includes('/'))
    return months[parseInt(dueDate.split('/')[1]!, 10) - 1]!.description;

  return months[parseInt(dueDate.split('-')[1]!, 10) - 1]!.description;
}

export function formatDueDate(dueDate: string) {
  return dueDate.split('-').reverse().join('/');
}
